import React from 'react';
import { Button, Dropdown, Spin, theme } from 'antd';
import { ShopOutlined, DownOutlined } from '@ant-design/icons';

interface StoreSelectorProps {
  allowedStores: Array<{ id: string; name: string }>;
  activeStoreId: string | null;
  isSwitchingStore: boolean;
  isMobile: boolean;
  onSwitchStore: (storeId: string) => void;
}

const { useToken } = theme;

export const StoreSelector: React.FC<StoreSelectorProps> = ({
  allowedStores,
  activeStoreId,
  isSwitchingStore,
  isMobile,
  onSwitchStore,
}) => {
  const { token } = useToken();
  if (isSwitchingStore) return <Spin size="small" style={{ marginLeft: 8 }} />;

  // token-aware: hereda el color de texto del tema activo (light/dark)
  const ink = token.colorTextBase;
  const activeStore = allowedStores.find((s) => s.id === activeStoreId);

  if (allowedStores.length > 1) {
    const storeDropdownItems = {
      items: allowedStores.map((s) => ({
        key: s.id,
        label: s.name,
        icon: <ShopOutlined style={{ color: s.id === activeStoreId ? '#ff6c00' : undefined }} />,
        onClick: () => onSwitchStore(s.id),
      })),
    };

    return (
      <Dropdown menu={storeDropdownItems} trigger={['click']}>
        <Button
          type="text"
          style={{
            color: ink,
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            height: '40px',
            padding: '4px 12px',
            borderRadius: 8,
          }}
        >
          <ShopOutlined style={{ color: '#ff6c00', fontSize: 16 }} />
          <span
            style={{
              maxWidth: isMobile ? 120 : 200,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              fontWeight: 600,
            }}
          >
            {activeStore?.name || 'Sede'}
          </span>
          <DownOutlined style={{ fontSize: 10, color: '#ff6c00' }} />
        </Button>
      </Dropdown>
    );
  }

  return (
    <div style={{ color: ink, display: 'flex', alignItems: 'center', gap: 8, padding: '4px 12px' }}>
      <ShopOutlined style={{ color: '#ff6c00', fontSize: 16 }} />
      <span
        style={{
          fontWeight: 600,
          maxWidth: isMobile ? 120 : 200,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {activeStore?.name || 'Sede Única'}
      </span>
    </div>
  );
};
